import { togglePlayerButton } from './customPlayer.js';

export function loadVimeoScript() {
    let script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.onload = function () {
        //console.log("✅ Vimeo API caricata con successo");
        initVimeoPlayer();
    };
    document.head.appendChild(script);
}

function initVimeoPlayer() {
    document.querySelectorAll('iframe.video-vimeo').forEach((video, i) => {
        let videoContainer = video.closest(".video-container");

        let playButton = videoContainer.querySelector(".custom-play-btn");

        // Crea il messaggio di stato per screen reader 
        let statusMessage = document.createElement("span");
        statusMessage.setAttribute("aria-live", "polite");
        statusMessage.classList.add("sr-only");
        videoContainer.appendChild(statusMessage);

        // Aggiunta attributi ARIA al pulsante (come in Vimeo)
        playButton.setAttribute("role", "button");
        playButton.setAttribute("aria-label", "Riproduci video");
        playButton.setAttribute("tabindex", "0");
        var player = new Vimeo.Player(video);
        var videoId = video.getAttribute("data-video-id");
        
        // console.log("🔃 Player Vimeo loading");
        // player.on('loaded', function () {
        //     player.play()
        //         .then(() => player.pause())
        //         .then(() => player.setCurrentTime(0)) // Ensure it's at the first frame
        //         .then(() => {
        //             // console.log("⏮️ Video paused at first frame");
        //         })
        //         .catch(function (error) {
        //             console.warn("⚠️ Preload/reset error:", error.name);
        //         });
        // });

        playButton.addEventListener("click", function (e) {
            e.preventDefault();
            document.getElementById(`videoCover${videoId}`).style.display = "none";
            player.play().then(() => {
                player.setVolume(1);
                togglePlayerButton(playButton, false);
                playButton.setAttribute("aria-label", "Pausa video");
                statusMessage.textContent = "Il video è in riproduzione.";
            });
        });

        // Accessibilità tastiera: gestione tasto "Enter" e "Space"
        playButton.addEventListener("keydown", function (e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                playButton.click();
            }
        });
    });
}